var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"type":"dark","variant":"dark"}},[_c('b-navbar-nav',[_c('b-nav-item',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }